<template>
  <div class="instructor-box campton-font">
    <div
      class="btn-radius overflow-hidden shadow-lg instructor-bg-color p-6"
      :style="[customCss]"
    >
      <div
        class="font-bold mb-4 text-2xl instructor-heading-color instructor-title"
      >
        {{ $t('frontend_instructors') }}
      </div>
      <div class="instructor-text-color">
        <div
          class="py-4 instructor-list-item mt-4"
          v-for="(instructor, index) in instructors"
          :key="index"
        >
          <div class="flex space-x-4">
            <div class="flex justify-center items-center">
              <div
                class="w-10 h-10 rounded-full"
                :style="{
                  'background-size': 'cover',
                  'background-repeat': 'no-repeat',
                }"
              >
                <img
                  class="w-10 h-10 rounded-full object-cover"
                  :src="instructor.profile_image"
                />
              </div>
            </div>
            <div class="flex justify-center items-center">
              <div class="font-bold">{{ instructor.name }}</div>
            </div>
          </div>
          <div class="text-sm mt-2 desc">
            {{ instructor.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Instructors',
  props: {
    instructors: {},
    getThemeSettings: {},
  },
  computed: {
    themeSettings() {
      return this.getThemeSettings();
    },
    customCss() {
      return {
        '--instructor-bg-color': this.themeSettings.configuration_options
          .section_bg_color,
        '--instructor-content-color': this.themeSettings.configuration_options
          .section_content_color,
        '--instructor-heading-color': this.themeSettings.configuration_options
          .section_heading_color,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.instructor-heading-color {
  color: var(--instructor-heading-color);
}
.instructor-bg-color {
  background: var(--instructor-bg-color);
}
.instructor-text-color {
  color: var(--instructor-content-color);
}
.instructor-list-item {
  border-top: 1px solid #d3d3d359;
  &:first-child {
    border: none;
  }
  .desc {
    //  color: #989ab2;
  }
}
</style>